import { S3, config } from 'aws-sdk';
import axios from 'axios';

const bucketName = 'vida-vod';

export default {
  data() {
    return {
      multiFiles: [],
      fileBlob: null,
      fileKey: null,
      filesUploading: [],
      totalFilesToCreate: 0,
      downloadingFile: null,
      isResearchVideo: false
    };
  },
  mounted() {
    console.log('mounte files', S3, config);
    config.update({
      maxRetries: 2,
      httpOptions: {
        timeout: 60000 * 8,
        connectTimeout: 8000
      }
    });
  },
  methods: {
    startUpload(file) {
      this.filesUploading.push(file);
    },
    isVideoFile(file) {
      if (!file || !file.name) {
        return false;
      }
      const fileName = file.name;
      let extension = '';
      if (fileName) {
        extension = fileName.substr(fileName.lastIndexOf('.') + 1);
      }
      extension = extension.toLowerCase();
      const videoExtensions = [
        '3gp',
        '3g2',
        'avi',
        'flv',
        'm4p',
        'm4v',
        'mov',
        'mp2',
        'mp4',
        'mpe',
        'mpeg',
        'mpg',
        'mpv',
        'mts',
        'ogg',
        'qt',
        'svi',
        'webm',
        'wmv'
      ];
      return videoExtensions.includes(extension);
    },
    buildS3VideoUploadKey(projectId, videoFileName) {
      // Build the S3 key: <project_id>/<file_name>, all lowercase, spaces converted to underscores
      const fileKey =
        '' +
        projectId +
        '/raw/' +
        Date.now() +
        '_' +
        encodeURIComponent(
          videoFileName
            .split(' ')
            .join('_')
            .toLowerCase()
        );
      return fileKey;
    },
    buildS3FileUploadKey(projectId, videoFileName) {
      // Build the S3 key: <project_id>/<file_name>, all lowercase, spaces converted to underscores
      const fileKey =
        '' +
        projectId +
        '/' +
        Date.now() +
        '_' +
        encodeURIComponent(
          videoFileName
            .split(' ')
            .join('_')
            .toLowerCase()
        );
      return fileKey;
    },
    buildS3VideoPlaybackKey(projectId, videoFileName) {
      const fileKey =
        projectId +
        '/converted/hls/' +
        encodeURIComponent(
          videoFileName
            .split(' ')
            .join('_')
            .toLowerCase()
        ) +
        '.m3u8';
      return fileKey;
    },
    uploadFileToS3(file, model) {
      this.$set(model, 'uploadProgress', 0);
      this.$set(model, 'uploadLoaded', 0);
      this.$set(model, 'uploadTotal', 0);
      this.$set(model, 'errorUploading', false);
      this.$emit('start-upload', model);

      const s3 = new S3();
      const isVideoUpload = this.isVideoFile(file) && this.isResearchVideo;
      const bucket = isVideoUpload
        ? process.env.VUE_APP_FILES_S3_BUCKET_VIDEOS
        : process.env.VUE_APP_FILES_S3_BUCKET;
      const managedUpload = s3.upload(
        {
          Bucket: bucket,
          Key: model.fileKey,
          Body: file,
          ACL: 'private'
        },
        (err, data) => {
          if (err) {
            this.$set(model, 'errorUploading', true);
          } else {
            this.$emit('upload-end', model, file, isVideoUpload);
          }
        }
      );

      managedUpload.on('httpUploadProgress', progress => {
        const percentUploaded = Math.floor(
          (progress.loaded / progress.total) * 100
        );
        //console.log(':perce', percentUploaded);
        this.$set(model, 'uploadProgress', percentUploaded);
        this.$set(model, 'uploadLoaded', progress.loaded);
        this.$set(model, 'uploadTotal', progress.total);
      });
    },
    createFile(fileBlob, model, isResearchVideo) {
      if (!fileBlob && model.linkUrl == '') {
        this.showErrorMessage('Please upload a file or add a link');
        return;
      }

      const formData = new FormData();
      if (isResearchVideo) {
        formData.append('fileType', 'Video');
        formData.append('fileName', fileBlob.name);
        formData.append('fileKey', model.fileKey);
      } else if (fileBlob) {
        formData.append('fileType', 'File');
        formData.append('fileName', fileBlob.name);
        formData.append('fileKey', model.fileKey);
      } else if (!fileBlob && model.linkUrl != '') {
        formData.append('fileType', 'Link');
        formData.append('linkUrl', model.name);
      }
      this.axiosRequest('post', 'Files/Content', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => {
          let org_id = this.$route.params.organizationID;
          if (!org_id) org_id = this.$store.getters.userOrganization;

          return axios.all([
            this.axiosRequest(
              'post',
              `Projects/${this.$route.params.projectID}/Files/${response.data.fileID}`,
              {}
            ),
            this.axiosRequest('put', `Files/${response.data.fileID}`, {
              fileID: response.data.fileID,
              organizationID: org_id,
              name: model.name,
              linkUrl: model.linkUrl,
              description: model.description
            })
          ]);
        })
        .then(
          axios.spread((response, file) => {
            file = file.data;
            if (file.fileType == 'Link') {
              //FileForm this
              this.$emit('created', file);

              this.showSuccessMessage(
                'Link ' + file.name + ' created successfully'
              );
            } else {
              //ProjectShow this
              this.projectFiles.push(file);

              this.showSuccessMessage(
                'File ' + file.name + ' uploaded successfully'
              );
            }
          })
        )
        .catch(error => {
          this.showErrorMessage(error);
        });
    },
    updateFile(fileBlob, model) {
      if (model.fileID) {
        const formData = new FormData();
        let is_upload = false;
        let needs_content_calling = false;
        if (model.linkUrl && fileBlob == null) model.fileType = 'Link';

        if (fileBlob instanceof File) {
          needs_content_calling = true;
          is_upload = true;
          const fileName = fileBlob.name;
          //this.fileKey = this.buildS3FileUploadKey(this.projectId, fileName);

          formData.append('fileType', 'File');
          formData.append('fileName', fileName);
          formData.append('fileKey', model.fileKey);
        } else if (model.fileType == 'Link') {
          //needs_content_calling = true;
          formData.append('fileType', 'Link');
          formData.append('linkUrl', model.name);
        }

        if (needs_content_calling) {
          this.axiosRequest('put', `Files/${model.fileID}/Content`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then(() => {
              //this.fileBlob = null;
            })
            .catch(error => {
              this.showErrorMessage(error);
            });
        }

        let org_id = this.$route.params.organizationID;
        if (!org_id) org_id = this.$store.getters.userOrganization;

        this.axiosRequest('put', `Files/${model.fileID}`, {
          fileID: model.fileID,
          organizationID: org_id,
          name: model.name,
          linkUrl: model.linkUrl,
          description: model.description,
          fileType: model.fileType
        })
          .then(file => {
            file = file.data;
            if (file.fileType == 'Link') {
              //FileForm this
              this.$emit('updated', file);
            } else {
              this.showSuccessMessage('File updated successfully');
              //this is projectshow and must be a change with upload
              if (this.updatedFile) {
                this.updatedFile(file);
              } else {
                this.$emit('updated', file);
              }
            }
          })
          .catch(error => {
            this.showErrorMessage(error);
          });
      }
    },
    uploadEnd(model, fileBlob, isResearchVideo) {
      console.log('uploadEnd', model, fileBlob);

      if (!model.fileID) this.createFile(fileBlob, model, isResearchVideo);
      else this.updateFile(fileBlob, model);

      /*for (let i = 0; i < this.filesUploading.length; i++) {
        if (this.filesUploading[i] == model) {
          this.filesUploading.splice(i, 1);
          break;
        }
      }*/
    },
    downloadVideoFromS3(videoFile) {
      this.downloadingFile = videoFile;
      this.$set(videoFile, 'downloadPercentage', 0);
      const videoKey = videoFile.fileKey;
      const s3 = new S3({ params: { Bucket: bucketName } });
      const params = {
        Bucket: bucketName,
        Key: videoKey
      };
      const request = s3.getObject(params, (err, data) => {
        if (err) {
          this.showErrorMessage('Error downloading file, please retry again');
        } else {
          const blob = new Blob([data.Body], { type: data.ContentType });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = videoFile.fileName;
          link.click();
        }
      });
      request.on('httpDownloadProgress', progress => {
        const percentage = Math.round((progress.loaded / progress.total) * 100);
        //console.log('::', percentage);
        this.$set(videoFile, 'downloadPercentage', percentage);

        if (percentage == 100) {
          this.downloadingFile = null;
        }
      });
    },
    uploadCover(fileBlob, project) {
      const formData = new FormData();
      formData.append('fileContent', fileBlob);
      formData.append('id', project.projectID);

      this.axiosRequest(
        'put',
        `Projects/${project.projectID}/CoverImage`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
        .then(response => {
          console.log(response);
          project.coverImageContentUrl = response.data.coverImageContentUrl;
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    }
  }
};
